export default {
    product: 'Product name',
    remainingStock: 'Remaining stock',
    owner: 'Owner',
    productId: 'Product ID',
    productName: 'Product name',
    ownerDealerId: 'Owner ID',
    ownerName: 'Owner name',
    statuses: {
        status0: 'Disapproved',
        status1: 'In stock',
        status2: 'Tranporting',
        status3: 'Transported',
        status4: 'Archived'
    }
}
